import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Skeleton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLUMN_HEADERS, COLUMN_WIDTHS } from './columnConfig';

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    height: '100%',
    overflow: 'auto',
    marginBottom: theme.spacing(6),
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(4),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

const SKELETON_ROW_COUNT = 6;

export const SetsConfigSearchResultsSkeleton = (): JSX.Element => {
    const skeletonRows = Array.from({ length: SKELETON_ROW_COUNT }, (_, i) => i);

    return (
        <StyledTableContainer>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="left" width={COLUMN_WIDTHS.name}>{COLUMN_HEADERS.name}</StyledTableCell>
                        <StyledTableCell align="left" width={COLUMN_WIDTHS.productKey}>{COLUMN_HEADERS.productKey}</StyledTableCell>
                        <StyledTableCell align="left" width={COLUMN_WIDTHS.locale}>{COLUMN_HEADERS.locale}</StyledTableCell>
                        <StyledTableCell align="left" width={COLUMN_WIDTHS.modifiedDate}>{COLUMN_HEADERS.modifiedDate}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {skeletonRows.map((index) => (
                        <TableRow key={`skeleton-${index}`}>
                            <StyledTableCell align="left" width={COLUMN_WIDTHS.name}><Skeleton animation="wave" /></StyledTableCell>
                            <StyledTableCell align="left" width={COLUMN_WIDTHS.productKey}><Skeleton animation="wave" /></StyledTableCell>
                            <StyledTableCell align="left" width={COLUMN_WIDTHS.locale}><Skeleton animation="wave" /></StyledTableCell>
                            <StyledTableCell align="left" width={COLUMN_WIDTHS.modifiedDate}><Skeleton animation="wave" /></StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};
